export function lerp(min: number, t: number, max: number): number {
  return (max - min) * t + min;
}

export function invLerp(min: number, value: number, max: number): number {
  return (value - min) / (max - min);
}

export function remap(
  fromMin: number,
  fromMax: number,
  value: number,
  toMin: number,
  toMax: number
): number {
  const t = invLerp(fromMin, value, fromMax);
  return lerp(toMin, t, toMax);
}
